import { createLazyFileRoute } from '@tanstack/react-router';

import { DefaultLayout } from '@src/layout';
import { IndustryDetail } from '@src/pages/Industries';

export const Route = createLazyFileRoute('/industries/mssp')({
  component: MSSPIndustryPage,
});

function MSSPIndustryPage() {
  return (
    <DefaultLayout>
      <IndustryDetail industryId="mssp" />
    </DefaultLayout>
  );
}
